import React, { Component } from 'react';
import { Col } from 'antd';

import { StyledRow, ParcelName, StyledButton } from 'components/Styled';

class BoxSelectionRow extends Component {
  state = {
    quantity: 0,
    length: null,
    width: null,
    height: null,
    drawerVisible: false,
    drawerKey: false // set key to reset default value
  };

  handleAddClick = () => {
    const { boxType, boxSize } = this.props;

    if (!localStorage.getItem('popup_volume_weight')) {
      this.props.openStaticPopup(this.props.getVolumeWeightPopup());
      localStorage.setItem('popup_volume_weight', 'true');
    }

    if (this.props.boxSize)
      return this.props.handleDrawerSubmit({ boxType, boxSize });
    this.props.handleDrawerOpen({ boxType, boxSize });
  };

  render() {
    const { boxType } = this.props;
    return (
      <>
        <StyledRow type="flex" align="middle" key={boxType}>
          <Col span={6} style={{ textAlign: 'center' }}>
            <img
              src={this.props.boxImage}
              style={this.props.boxImageStyle}
              alt={this.props.t(`quotation.parcel_form.boxes.${boxType}`)}
            />
          </Col>
          <Col span={6}>
            <ParcelName>
              {`${this.props.t('quotation.ship')}${this.props.t(
                `quotation.parcel_form.boxes.${boxType}`
              )}`}
            </ParcelName>
          </Col>
          <Col span={12} style={{ textAlign: 'right' }}>
            <StyledButton
              ghost
              type="secondary"
              width={151}
              className="theme-button"
              onClick={this.handleAddClick}>
              {this.props.boxType === 'envelope'
                ? this.props.t('quotation.new_envelope')
                : this.props.t('quotation.input_size')}
            </StyledButton>
          </Col>
        </StyledRow>
      </>
    );
  }
}

export default BoxSelectionRow;
